/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const TipoServicoSegment = ({ lentes, value, onChange, disabled }) => {
  if (!lentes || lentes.length <= 1) return null;

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next) => {
        if (next) onChange(next);
      }}
      disabled={disabled}
      aria-label="Tipo de serviço"
      sx={{ flexWrap: 'wrap' }}
    >
      {lentes.map((lente) => (
        <ToggleButton key={lente.id} value={lente.id} sx={{ px: 2 }}>
          {lente.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

TipoServicoSegment.propTypes = {
  lentes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TipoServicoSegment.defaultProps = {
  lentes: [],
  value: null,
  disabled: false,
};

export default TipoServicoSegment;
